import * as styles from "./PdfPage.css";

import type { JSX } from "react";

import { PagePointerProvider } from "@embedpdf/plugin-interaction-manager/react";
import { RenderLayer } from "@embedpdf/plugin-render/react";
import type { PageLayout } from "@embedpdf/plugin-scroll";
import { SearchLayer } from "@embedpdf/plugin-search/react";
import { SelectionLayer } from "@embedpdf/plugin-selection/react";
import { TilingLayer } from "@embedpdf/plugin-tiling/react";

import { usePdfViewerContext } from "./PdfViewer.context";

export function PdfPage({ pageIndex, pageNumber }: PageLayout): JSX.Element {
  const { documentId } = usePdfViewerContext();

  return (
    <PagePointerProvider
      data-slot="pdf-viewer-page"
      data-page={pageNumber}
      className={styles.page}
      documentId={documentId}
      pageIndex={pageIndex}
    >
      <RenderLayer
        documentId={documentId}
        pageIndex={pageIndex}
        className={styles.render}
      />

      <TilingLayer documentId={documentId} pageIndex={pageIndex} />

      <SearchLayer documentId={documentId} pageIndex={pageIndex} />

      <SelectionLayer documentId={documentId} pageIndex={pageIndex} />
    </PagePointerProvider>
  );
}
